import { useQuery } from 'react-apollo';

import { useSessionData } from '@confluence/session-data';
import { CreateSpaceQuery } from '@confluence/create-space-preload/entry-points/preloadCreateSpace';
import type {
	CreateSpaceQueryType,
	CreateSpaceQueryUserConfluenceOperationsType as Operations,
} from '@confluence/create-space-preload/entry-points/preloadCreateSpace';

export const useCanCreateSpace = () => {
	const { isLicensed } = useSessionData();

	const { data: canCreateData } = useQuery<CreateSpaceQueryType>(
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
		CreateSpaceQuery,
		{
			skip: !isLicensed,
		},
	);

	const canCreateSpace = Boolean(
		canCreateData?.user?.confluence?.operations.some(
			(obj: Operations | null) => obj?.operation === 'create_space',
		),
	);

	return { canCreateSpace };
};
